import type { AnchorHTMLAttributes } from 'react';
import { isIosHomeScreenApp, outboundHref, type OutboundBrowser } from '@higgins/utils';

export interface OutboundLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'target' | 'rel'> {
  /** An https address outside the app (e.g. a record in Dynamics). */
  href: string;
  /** The browser it opens in from a Home Screen app (default Safari); SharePoint uses Edge (#615). */
  openIn?: OutboundBrowser;
}

/**
 * A link that leaves the app without stranding the user. Normally it opens a
 * new tab, so the app stays in its own. A Home Screen app on an iPad has no
 * tabs: the new page would take over the full-screen window with no way back,
 * so there the link opens in another browser instead and the app stays where
 * it was (`@higgins/utils` outbound-href).
 */
export function OutboundLink({ href, openIn = 'safari', children, ...props }: OutboundLinkProps) {
  if (isIosHomeScreenApp()) {
    return (
      <a {...props} href={outboundHref(href, openIn, true)}>
        {children}
      </a>
    );
  }
  return (
    <a {...props} href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
